import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What is the MERN stack?",
    
    description:
      "The MERN stack uses MongoDB, Express.js, React.js, and Node.js to build full-stack applications. It enables developers to use JavaScript for both frontend and backend, allowing faster development, seamless integration, and efficient end-to-end web application creation.",
  },
  {
    title: "What is JWT and how is it used in MERN?",
    
    description:
      "JWT (JSON Web Token) provides secure user authentication in MERN applications. It verifies users during login, protects restricted routes, manages sessions, and ensures only authorized users can access specific parts of the application.",
  },
  {
    title: "What is REST API and why is it important in MERN?",
    
    description:
      "A REST API enables communication between the frontend and backend. In the MERN stack, Express.js creates APIs that React uses to exchange data, making applications dynamic, interactive, and capable of real-time user-driven updates.",
  },
  {
    title: "What kinds of projects can I build with the MERN stack?",
    
    description:
      "With MERN, you can build social media platforms, e-commerce sites, blogs, dashboards, chat apps, job portals, streaming services, and real-time applications. Its flexibility makes it suitable for almost any modern web project.",
  },
  {
    title: "Why is MERN so popular among developers?",
    
    description:
      "MERN is popular because it uses one language—JavaScript—for the entire stack. Developers don’t need to switch languages for frontend or backend, making learning easier and development faster, smoother, and more efficient.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
